import React from 'react';
import { Button } from 'reactstrap';
import moment from 'moment';

export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_FETCH_LIST_REQUEST = {
    pageNumber: 0,
    pageSize: DEFAULT_PAGE_SIZE,
};

const STATUS_CHIP_VARIANTS = {
    SUCCESS: 'success',
    COMPLETED: 'success',
    PROCESSING: 'processing',
    IN_PROGRESS: 'processing',
    PENDING: 'pending',
    ONHOLD: 'onhold',
    FAILURE: 'failure',
    PARTIAL_FAILURE: 'failure',
};

const getStatusChipVariant = (status) => {
    if (!status) return 'default';
    return STATUS_CHIP_VARIANTS[status.toUpperCase()] || 'default';
};

const formatStatusLabel = (status) => {
    if (!status) return 'N/A';
    return status.replace(/_/g, ' ');
};

export const StatusChip = ({ status, onClick }) => {
    const variant = getStatusChipVariant(status);
    const isClickable = typeof onClick === 'function';

    return (
        <span
            className={`bulk-case-updation__status-chip bulk-case-updation__status-chip--${variant}${isClickable ? ' bulk-case-updation__status-chip--clickable' : ''}`}
            onClick={isClickable ? onClick : undefined}
            role={isClickable ? 'button' : undefined}
            tabIndex={isClickable ? 0 : undefined}
            onKeyPress={isClickable ? (e) => e.key === 'Enter' && onClick() : undefined}
        >
            {formatStatusLabel(status)}
        </span>
    );
};

export const CASE_VIEW_COLUMNS = (context) => [
    {
        Header: 'Uploaded Date',
        id: 'uploadedDate',
        accessor: d => (
            <div>
                {d.uploadedDate
                    ? moment(d.uploadedDate, ['DD-MM-YYYY', moment.ISO_8601], true).isValid()
                        ? moment(d.uploadedDate, ['DD-MM-YYYY', moment.ISO_8601], true).format('DD-MM-YYYY')
                        : d.uploadedDate
                    : 'N/A'}
            </div>
        ),
    },
    {
        Header: 'Uploaded By',
        id: 'uploadedBy',
        accessor: p => <div>{p.uploadedBy || 'N/A'}</div>,
    },
   {
    Header: 'Status',
    id: 'status',
    accessor: p => {
        const isFailure = p.status === 'FAILURE' || p.status === 'PARTIAL_FAILURE';
        const fileKey = p.failureFileKey || p.proceedFileKey;

        return (
            <StatusChip
                status={p.status}
                onClick={
                    isFailure && fileKey
                        ? () => context.handleFileDownload(fileKey)
                        : undefined
                }
            />
        );
    },
    },
    {
        Header: 'Uploaded File',
        id: 'uploadedFileKey',
        accessor: p => (
            <Button
                color="link"
                className="p-0"
                disabled={!p.uploadedFileKey}
                onClick={() => context.handleFileDownload(p.uploadedFileKey)}
            >
                <i className="fa fa-download mr-1" />
                Download
            </Button>
        ),
    }
];
